import React from "react";
import { useTranslation } from "react-i18next";
import { DisplayableJSONStructure } from "common/services/formBuilderService/types";
import { CustomMapGeometryAdditionalFields } from "common/utils/customMaps";
import { Label } from "../../AddressPanel/PropertyOverview/__styles__";
import {
  Table,
  TableBody,
  TableCell,
  TableCellContainer,
  TableHeader,
  TableRow,
} from "../../Common/__styles__/StripedTable";
import { TabContainer } from "../Property/__styles__/PropertyPage";

export type GuestCustomObjectTabProps = {
  additionalFields: CustomMapGeometryAdditionalFields;
  config: DisplayableJSONStructure;
};

export const Overview = ({
  additionalFields,
  config,
}: GuestCustomObjectTabProps) => {
  const { t } = useTranslation();
  const order = config.uiSchema["ui:order"] ?? Object.keys(additionalFields);

  if (!order.length) {
    return null;
  }

  return (
    <TabContainer>
      <Table spacing="negative">
        <TableHeader>
          <TableRow header>
            <TableCell>{t("common-custom-object-properties")}</TableCell>
          </TableRow>
        </TableHeader>

        <TableBody>
          {order.map(key => (
            <TableRow header={false} key={key}>
              <TableCell containsTooltip>
                <TableCellContainer>
                  <Label size="narrow">{key}</Label>
                </TableCellContainer>
              </TableCell>
              <TableCell style={{ whiteSpace: "normal" }}>
                <span>{additionalFields[key]}</span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TabContainer>
  );
};
